import { FormControl, InputLabel, MenuItem, Select } from "@mui/material"
import useSelect from "hooks/use_select"
import useTranslation from "hooks/use_translation"
import { useEffect, useState } from "react"
import useAppStore from "../../../store/app"
// import countries from "config/countries"

const CountryCode = () => {
  const id = "country_code"

  const [countries, setCountries] = useState([])

  const getCountryCodes = useAppStore((state) => state.getCountryCodes)
  const { lang, direction } = useAppStore((state) => state.meta)

  useEffect(() => {
    getCountryCodes().then((data) => setCountries(data))
  }, [lang])

  const { fields } = useTranslation()

  const validate = () => {
    return ""
  }

  const { handleChange, inputValue } = useSelect(id, validate)

  return (
    <FormControl sx={{ minWidth: 120 }}>
      <InputLabel
        shrink
        htmlFor={id}
        variant="subtitle1"
        sx={{
          position: "static",
        }}
      >
        {fields?.country_code_title}
      </InputLabel>
      <Select
        value={inputValue}
        onChange={handleChange}
        sx={{
          backgroundColor: "#F8F8FA",
          borderRadius: "8px",
          height: "50px",
          fontWeight: 500,
        }}
      >
        {countries.map((country, i) => (
          <MenuItem
            dir={direction}
            key={i}
            value={country.code}
            sx={{ whiteSpace: "normal", maxWidth: "388px" }}
          >
            {country.flag} ({country.code}) {country.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default CountryCode
